import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface H3Props extends ComponentPropsWithRef<"h3"> {
  blockPath: string;
  styles: Record<string, StyleValue>;
  text: string;
}

export const H3 = forwardRef<HTMLHeadingElement, H3Props>(
  ({ text, blockPath, styles, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <h3
        ref={ref}
        className={classNames(
          "wb-text-h3-color wb-text-h3 wb-font-h3 wb-leading-h3 wb-tracking-h3 wb-whitespace-pre-wrap",
          className,
        )}
        style={inlineStyles}
        data-testid="builder-heading"
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </h3>
    );
  },
);

H3.displayName = "H3";
